import { useUserSettings } from 'context/DataContext';
import React from 'react';
import TermsAndConditions from './TermsAndConditions';
import ScrollableDialog from './ScrollableDialog';
import { useMsal } from '@azure/msal-react';
import { getBrowserName, getOS } from 'helpers/infraestructureHelper';
import { useAuth } from 'auth';

const TermsAndConditionsDialog = () => {
  const { setTokenInfo, tokenInfo } = useAuth();
  const { openTAC, postTACFetchLazy, loadingPostTAC } = useUserSettings();
  const { instance } = useMsal();

  const handleAcceptTerms = () => {
    postTACFetchLazy({
      body: JSON.stringify({
        validated: true,
        authenticationMethod: tokenInfo.authenticationMethod,
        fabricEvent: {
          type: 'Update_contact',
          AppUrl: window.location.href,
          browser: getBrowserName(navigator.userAgent),
          operatingSystem: getOS(navigator.userAgent),
        },
      }),
    });
  };

  const handleDeclineTerms = () => {
    setTokenInfo(null);
    instance.logoutRedirect();
  };
  return (
    <ScrollableDialog
      isOpen={openTAC}
      onConfirm={handleAcceptTerms}
      onDecline={handleDeclineTerms}
      title="Terms and Conditions"
      confirmButton="Accept terms"
      declineButton="Cancel"
      loading={loadingPostTAC}
    >
      <TermsAndConditions />
    </ScrollableDialog>
  );
};

export default TermsAndConditionsDialog;
